module.exports = __webpack_public_path__ + "fonts/Gibson-Light.8958ecd1.woff2";